const dotenv = {
  SERVER: process.env.REACT_APP_SERVER_URL,
  SERVER_URL: process.env.REACT_APP_SERVER_URL2,
};

export default dotenv;
